import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <CommentsSection />
        <UpdatesSection />
        <FAQSection />
        <TopicsSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
        <CardsSection />
        <AppSection />
        <IndexSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}